import { useTranslation } from "react-i18next";
import LegalPageLayout from "../../components/LegalPageLayout";

const navConfig = [
  { id: "introduction", labelKey: "terms.nav.introduction", icon: "terms1.svg" },
  { id: "acceptance", labelKey: "terms.nav.acceptance", icon: "terms6.svg" },
  {
    id: "partner-obligations",
    labelKey: "terms.nav.partnerObligations",
    icon: "terms2.svg",
  },
  { id: "services", labelKey: "terms.nav.services", icon: "terms7.svg" },
  { id: "liability", labelKey: "terms.nav.liability", icon: "terms8.svg" },
  { id: "contact-us", labelKey: "terms.nav.contactUs", icon: "terms5.svg" },
];

function TermsAndConditions() {
  const { t } = useTranslation();
  const partnerObligations = t("terms.partnerObligations.items", {
    returnObjects: true,
  });

  const navItems = navConfig.map((item) => ({
    id: item.id,
    label: t(item.labelKey),
    icon: item.icon,
  }));

  return (
    <LegalPageLayout
      title={t("terms.title")}
      lastUpdated="2023-10"
      navItems={navItems}
      navAriaLabel={t("terms.navAriaLabel")}
    >
      <section id="introduction" className="legal-section">
        <h2 className="legal-section-title">{t("terms.introduction.title")}</h2>
        <p className="legal-text">{t("terms.introduction.p1")}</p>
        <p className="legal-text">{t("terms.introduction.p2")}</p>
      </section>

      <section id="acceptance" className="legal-section">
        <h2 className="legal-section-title">{t("terms.acceptance.title")}</h2>
        <p className="legal-text">{t("terms.acceptance.p1")}</p>
        <p className="legal-text">{t("terms.acceptance.p2")}</p>
      </section>

      <section id="partner-obligations" className="legal-section">
        <h2 className="legal-section-title">
          {t("terms.partnerObligations.title")}
        </h2>
        <p className="legal-text">{t("terms.partnerObligations.intro")}</p>
        <ul className="legal-list">
          {partnerObligations.map((item) => (
            <li key={item.label}>
              <strong>{item.label}:</strong> {item.text}
            </li>
          ))}
        </ul>
      </section>

      <section id="services" className="legal-section">
        <h2 className="legal-section-title">{t("terms.services.title")}</h2>
        <p className="legal-text">{t("terms.services.p1")}</p>
        <p className="legal-text">{t("terms.services.p2")}</p>
      </section>

      <section id="liability" className="legal-section">
        <h2 className="legal-section-title">{t("terms.liability.title")}</h2>
        <p className="legal-text">{t("terms.liability.p1")}</p>
        <p className="legal-text">{t("terms.liability.p2")}</p>
      </section>

      <section id="contact-us" className="legal-section">
        <h2 className="legal-section-title">{t("terms.contactUs.title")}</h2>
        <p className="legal-text">{t("terms.contactUs.p1")}</p>
      </section>
    </LegalPageLayout>
  );
}

export default TermsAndConditions;
